import { buildCarHudBadgeModel, renderCarHudBadgeHtml } from '@multirx/shared/game/carHudBadge.js';
import { rankingAtRound } from '@multirx/shared/game/archiveReplay.js';
import { formatDriverDisplayName } from '@multirx/shared/game/driverDisplayLabel.js';
import type { RaceHistoryReplay } from '@multirx/shared/types/raceHistory.js';

/** Badges place + nom pour chaque pilote au tour donné. */
export function buildArchiveRoundHudBadges(
  replay: RaceHistoryReplay,
  round: number,
  numParticipants: number,
  ownDriverId: number | null = null
): Map<number, string> {
  const ranking = rankingAtRound(replay, round, numParticipants);
  const rankByPlayer = new Map(ranking.map((r) => [r.playerIndex, r.rank]));
  const out = new Map<number, string>();
  for (const p of replay.participants) {
    const rank = rankByPlayer.get(p.playerIndex) ?? p.playerIndex + 1;
    out.set(
      p.playerIndex,
      renderCarHudBadgeHtml(
        buildCarHudBadgeModel({
          rank,
          cellBonus: null,
          driverName: formatDriverDisplayName(p.driverName, p.driverId, ownDriverId),
        })
      )
    );
  }
  return out;
}
